let _instance = null;

class PlayerSocket {
  get Instance() {
    if (_instance) return _instance;

    let _syncPosFunc = [];
    let _syncPhaseFunc;
    let _mask;
    let _isSecond = false;
    let _sliderSyncFuncs = [];
    let _loadRest = [];
    let _playersNum = 0;
    let _lastX = 0;
    let PhaseDic = {};

    class PS {
      registerLoadRest(func) {
        _loadRest.push(func);
      }

      notifyLoadRest() {
        while (_loadRest.length) {
          _loadRest.pop()();
        }
      }

      set lastX(val) {
        _lastX = val;
      }

      get lastX() {
        return _lastX;
      }

      set maskEl(maskEl) {
        this._maskEl = maskEl;
      }

      get maskEl() {
        return this._maskEl;
      }

      sliderSync(data) {
        _sliderSyncFuncs.forEach(f => f(data));
      }

      setSliderSyncFunc(func) {
        _sliderSyncFuncs.push(func);
      }

      r2pPosSync(pos, index, total) {
        _syncPosFunc.forEach(f =>
          f({ realPos: pos, index, total })
        );
      }

      r2pPhaseSync(phase) {
        PhaseDic[phase] = (PhaseDic[phase] || 0) + 1;
        if (PhaseDic[phase] === _playersNum - 1) {
          _syncPhaseFunc?.(phase);
        }
      }

      get isSecond() {
        const isSecond = _isSecond;
        if (!_isSecond) _isSecond = true;
        return isSecond;
      }

      get syncPosFunc() {
        return _syncPosFunc;
      }

      set syncPhaseFunc(func) {
        _syncPhaseFunc = func;
      }

      get syncPhaseFunc() {
        return _syncPhaseFunc;
      }

      set mask(el) {
        _mask = el;
      }

      get mask() {
        return _mask;
      }

      incPlayersNum() {
        ++_playersNum;
      }

      get playersNum() {
        return _playersNum;
      }
    }

    _instance = new PS();
    return _instance;
  }
}

export default PlayerSocket;
